import { InteractionModifierEvent } from '../models/interaction-modifier-event.model';

export const RESERVED_INTERACTION_MODIFIER_KEYS: Record<InteractionModifierEvent, keyof MouseEvent> = {
    [InteractionModifierEvent.SelectAllInRange]: 'shiftKey',
    [InteractionModifierEvent.SelectItemWithinRange]: 'ctrlKey'
};
